import {Injectable, Type} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MvsCrudService} from '../../../../core/shared/service/crud/mvs-crud.service';
import {MvsCrudModeEnum} from '../../../../core/shared/service/crud/mvs-crud-mode.enum';

/**
 * [CW-PERSON-REFACTOR] Generic CRUD service of {@code cw.CwCaseTypeTemplate}
 * ({@code /mvsa/cw/caseTypeTemplates}) — the reusable person-ROUTING profile.
 *
 * <h3>A configuration entity, so it must be configurable in the UI</h3>
 * {@code EntityMetaCategory.configuration}: the eight routing attributes are maintained by a
 * configurator, not by code, and the contents travel between environments as a seed bundle rather
 * than as a Java seeder. It has no child collections, so a flat config-page entry is the right
 * surface and no dedicated object page is needed.
 *
 * <h3>{@code name} is identity</h3>
 * It is the seed key ({@code cw.CwCaseTypeTemplate -> ["name"]}). Renaming a template breaks every
 * bundle that references it; the readable German wording belongs in {@code description}.
 */
@Injectable({
    providedIn: 'root',
})
export class CwCaseTypeTemplateService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/cw/caseTypeTemplates');
    }

    getObjectComponent(mode: MvsCrudModeEnum = MvsCrudModeEnum.update): Type<any> {
        return null;
    }

}
